import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import {pathnames as P} from 'common/constants/pathnames';
import accountSideBar from '../../assets/account_side_menu.svg';
import listSideBar from '../../assets/list.svg';
import styles from './styles.module.scss';
import PrivacyPolicyPopup from "../../../../common/components/PrivacyPolicyPopup";
import ModalContactSupport from "../../../../common/components/ModalContactSupport";

const SideBarView = ({name, family_name, email}) => {

    return (
      <div className={styles.sideBar}>
          <div className={styles.userInfo}>
              <img
                src={accountSideBar}
                alt="accountSideBar"
                className={styles.icon}
              />
              <h2 className={styles.fullName}>{name} {family_name}</h2>
              <p className={styles.email}>{email}</p>
          </div>
          <div className={styles.content}>
              <div className={styles.menu}>
                  <PrivacyPolicyPopup
                    label={(
                      <div className={styles.menuItemUser}>
                          <img src={listSideBar} alt="document" className={styles.icon}/>
                          <div className={styles.label}>תנאי שימוש ומדיניות פרטיות</div>
                      </div>
                    )}
                    showCheckbox={false}
                  />
                  <ModalContactSupport
                    showLabelIcon={true}
                    customLabelStyles={true}
                  />
              </div>
              <div className={styles.logoutItem}>
                  <NavLink
                    to={P.AUTH_LOGOUT}
                    className={styles.buttonLogout}
                  >
                      <span>התנתק</span>
                  </NavLink>
              </div>
          </div>
      </div>
    )
}


SideBarView.propTypes = {
    name: PropTypes.string,
    family_name: PropTypes.string,
    email: PropTypes.string
};

export default SideBarView;
